module.exports = __webpack_public_path__ + "static/media/6.7.ee9b0b1a.png";